<template>
    <div>
        <div class="panel-tag mt-3" v-if="topSellingItem.length == 0">
            {{$t('table.no_records')}}
        </div>
        <div v-else class="dataTables_wrapper dt-bootstrap4">
            <div class="row" data-spy="scroll" data-target="#itemSP" data-offset="0">
                <div class="col-sm-12 overflow-auto">
                    <b-table striped hover bordered :fields="fields" :items="topSellingItem" responsive>
                        <template #cell(index)="data">
                            {{data.index + 1}}
                        </template>
                        <template #cell(type)="data">
                            {{filterObj.itemType == "all" ? $t(`salon_report.item_types.${data.item.type}`) : data.item.type}}
                        </template>
                        <template #custom-foot>
                            <b-tr>
                                <b-td :colspan="filterObj.itemType == 'all' ? 1 : 2" class="border-top-bottom-2 text-right fw-700">{{$t('label.total')}}</b-td>
                                <b-td class="border-top-bottom-2 fw-500">{{topSellingTotal.sales.toFixed(2)}}</b-td>
                                <b-td class="border-top-bottom-2 fw-500">{{topSellingTotal.salesQty}}</b-td>
                                <b-td class="border-top-bottom-2 fw-500">{{topSellingTotal.credits.toFixed(2)}}</b-td>
                                <b-td class="border-top-bottom-2 fw-500">{{topSellingTotal.creditsQty}}</b-td>
                                <b-td class="border-top-bottom-2 fw-500">{{topSellingTotal.package.toFixed(2)}}</b-td>
                                <b-td class="border-top-bottom-2 fw-500">{{topSellingTotal.packageQty}}</b-td>
                                <b-td class="border-top-bottom-2 fw-500">{{topSellingTotal.total.toFixed(2)}}</b-td>
                                <b-td class="border-top-bottom-2 fw-500">{{topSellingTotal.totalQty}}</b-td>
                            </b-tr>
                        </template>
                    </b-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from 'lodash';
import {getSubTotal} from './../../../../assets/js/dashboard/salonReport/salonReport'
export default {
    name: 'topSellingItem',
    data(){
        return{
            topSellingItem: [],
            topSellingTotal: {},
            filterObj:{}
        }
    },
    computed:{
        fields(){
            var fArr = []
            if(this.filterObj.itemType != 'all'){
                fArr.push({key: "index", label: '#', thClass: 'thead-themed align-middle'})
            }
            var arr = [
                {key: "type", label: this.filterObj.itemType == "all" ? this.$i18n.t('label.item_type') : this.$i18n.t(`salon_report.item_types.${this.filterObj.itemType}`), thClass: 'thead-themed align-middle', sortable: true},
                {key: "sales", label: this.$i18n.t('salon_report.sales.sales'), thClass: 'thead-themed align-middle', sortable: true},
                {key: "salesQty", label: this.$i18n.t('salon_report.sales.sales') + " (" + this.$i18n.t('label.quantity') + ")", thClass: 'thead-themed align-middle', sortable: true},
                {key: "credits", label: this.$i18n.t('salon_report.sales.credit_redeem'), thClass: 'thead-themed align-middle', sortable: true},
                {key: "creditsQty", label: this.$i18n.t('salon_report.sales.credit_redeem') + " (" + this.$i18n.t('label.quantity') + ")", thClass: 'thead-themed align-middle', sortable: true},
                {key: "package", label: this.$i18n.t('salon_report.sales.package_redeem'), thClass: 'thead-themed align-middle', sortable: true},
                {key: "packageQty", label: this.$i18n.t('salon_report.sales.package_redeem') + " (" + this.$i18n.t('label.quantity') + ")", thClass: 'thead-themed align-middle', sortable: true},
                {key: "total", label: this.$i18n.t('table.header.total', {'item': ''}), thClass: 'thead-themed align-middle', sortable: true},
                {key: "totalQty", label: this.$i18n.t('table.header.total', {'item': this.$i18n.t('label.quantity')}), thClass: 'thead-themed align-middle', sortable: true},
            ]
            fArr.push(...arr)
            return fArr
        }
    },
    methods:{
        updateTable(item, filterObj){
            this.filterObj = filterObj
            this.topSellingItem = []

            var groupType = 'item.' + (filterObj.itemType == 'all' ? 'type' : 'itemID')
            var group = _.groupBy(item, groupType)
            for(var i in group){
                var title = filterObj.itemType == 'all' ? i : group[i][0].item.title
                group[i] = this.calculateTopSelling(group[i])
                this.topSellingItem.push({
                    type: title,
                    sales: parseFloat(group[i].sales).toFixed(2),
                    salesQty: group[i].salesQty,
                    credits: parseFloat(group[i].credits).toFixed(2),
                    creditsQty: group[i].creditsQty,
                    package: parseFloat(group[i].package).toFixed(2),
                    packageQty: group[i].packageQty,
                    total: parseFloat(group[i].sales + group[i].credits + group[i].package).toFixed(2),
                    totalQty: group[i].salesQty + group[i].creditsQty + group[i].packageQty
                })
            }
            
            this.getTotalData(this.topSellingItem)
            this.$emit('setExportData', this.topSellingItem, this.topSellingTotal)
        },
        getTotalData(item){
            this.topSellingTotal = {
                sales: 0,
                salesQty: 0,
                credits: 0,
                creditsQty: 0,
                package: 0,
                packageQty: 0,
                total: 0,
                totalQty: 0
            }
            for(var i=0; i<item.length; i++){
                for(var j in this.topSellingTotal){
                    this.topSellingTotal[j] += parseFloat(item[i][j])
                }
            }
            this.$emit('setTotalData', this.topSellingTotal)
        },
        calculateTopSelling(item){
            var obj = {
                sales: 0,
                salesQty: 0,
                credits: 0,
                creditsQty: 0,
                package: 0,
                packageQty: 0
            }
            for(var i=0; i<item.length; i++){
                if(item[i].redeem == "credits"){
                    obj.creditsQty++;
                    obj.credits += getSubTotal(item[i].price, item[i].discount, item[i].outstandings, item[i].tax.taxType, item[i].tax.tax)
                }else if(item[i].redeem == "package"){
                    obj.packageQty++;
                    obj.package += getSubTotal(item[i].price, item[i].discount, item[i].outstandings, item[i].tax.taxType, item[i].tax.tax)
                }else{
                    obj.salesQty++;
                    obj.sales += getSubTotal(item[i].price, item[i].discount, item[i].outstandings, item[i].tax.taxType, item[i].tax.tax)
                }
            }
            return obj
        }
    }
}
</script>
<style scoped>
.border-top-bottom-2{
    border-top-width:  2px !important;
    border-bottom-width:  2px !important;
}
</style>